import * as React from 'react';
import {cn} from 'src/lib/utils';

type Props = Omit<React.ComponentProps<'textarea'>, 'onChange'> & {
  onChange?: (value: string) => void;
};

export const Textarea = React.forwardRef(
  (props: Props, ref: React.Ref<HTMLTextAreaElement>) => {
    const {onChange, className, ...otherProps} = props;
    const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
      onChange?.(e.target.value);
    };
    return (
      <textarea
        ref={ref}
        {...otherProps}
        onChange={handleChange}
        className={cn(
          'placeholder:text-muted-foreground selection:bg-primary selection:text-primary-foreground dark:bg-input/30 border-input w-full min-w-0 rounded-md border bg-transparent px-3 py-2 text-sm shadow-xs transition-[color,box-shadow] outline-none disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50',
          'focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px]',
          'aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive',
          className,
        )}
      />
    );
  },
);
